import { render, staticRenderFns } from "./StrockTik.vue?vue&type=template&id=6ea8fa22&"
import script from "./StrockTik.vue?vue&type=script&lang=js&"
export * from "./StrockTik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports